(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

require("./scripts/libraries/jquery.appear.min");

require("./scripts/libraries/jquery.countTo");

require("./scripts/libraries/jquery.countdown");

require("./scripts/libraries/jquery.owl.carousel");

require("./scripts/libraries/easyResponsiveTabs");

},{"./scripts/libraries/easyResponsiveTabs":2,"./scripts/libraries/jquery.appear.min":3,"./scripts/libraries/jquery.countTo":4,"./scripts/libraries/jquery.countdown":5,"./scripts/libraries/jquery.owl.carousel":6}],2:[function(require,module,exports){
"use strict";

// Easy Responsive Tabs Plugin
// Author: Samson.Onna <Email : samson3d@gmail.com>
(function ($) {
  $.fn.extend({
    easyResponsiveTabs: function easyResponsiveTabs(options) {
      //Set the default values, use comma to separate the settings, example:
      var defaults = {
        type: 'default',
        //default, vertical, accordion;
        width: 'auto',
        fit: true,
        closed: false,
        activate: function activate() {} //Variables

      };
      var options = $.extend(defaults, options);
      var opt = options,
          jtype = opt.type,
          jfit = opt.fit,
          jwidth = opt.width,
          vtabs = 'vertical',
          accord = 'accordion';
      var hash = window.location.hash;
      var historyApi = !!(window.history && history.replaceState); //Events

      $(this).bind('tabactivate', function (e, currentTab) {
        if (typeof options.activate === 'function') {
          options.activate.call(currentTab, e);
        }
      }); //Main function

      this.each(function () {
        var $respTabs = $(this);
        var $respTabsList = $respTabs.find('ul.resp-tabs-list');
        var respTabsId = $respTabs.attr('id');
        $respTabs.find('ul.resp-tabs-list li').addClass('resp-tab-item');
        $respTabs.css({
          'display': 'block',
          'width': jwidth
        });
        $respTabs.find('.resp-tabs-container > div').addClass('resp-tab-content');
        jtab_options(); //Properties Function

        function jtab_options() {
          if (jtype == vtabs) {
            $respTabs.addClass('resp-vtabs');
          }

          if (jfit == true) {
            $respTabs.css({
              width: '100%',
              margin: '0px'
            });
          }

          if (jtype == accord) {
            $respTabs.addClass('resp-easy-accordion');
            $respTabs.find('.resp-tabs-list').css('display', 'none');
          }
        } //Assigning the h2 markup to accordion title


        var $tabItemh2;
        $respTabs.find('.resp-tab-content').before("<h2 class='resp-accordion' role='tab'><span class='resp-arrow'></span></h2>");
        var itemCount = 0;
        $respTabs.find('.resp-accordion').each(function () {
          $tabItemh2 = $(this);
          var $tabItem = $respTabs.find('.resp-tab-item:eq(' + itemCount + ')');
          var $accItem = $respTabs.find('.resp-accordion:eq(' + itemCount + ')');
          $accItem.append($tabItem.html());
          $accItem.data($tabItem.data());
          $tabItemh2.attr('aria-controls', 'tab_item-' + itemCount);
          itemCount++;
        }); //Assigning the 'aria-controls' to Tab items

        var count = 0,
            $tabContent;
        $respTabs.find('.resp-tab-item').each(function () {
          $tabItem = $(this);
          $tabItem.attr('aria-controls', 'tab_item-' + count);
          $tabItem.attr('role', 'tab'); //Assigning the 'aria-labelledby' attr to tab-content

          var tabcount = 0;
          $respTabs.find('.resp-tab-content').each(function () {
            $tabContent = $(this);
            $tabContent.attr('aria-labelledby', 'tab_item-' + tabcount);
            tabcount++;
          });
          count++;
        }); // Show correct content area

        var tabNum = 0;

        if (hash != '') {
          var matches = hash.match(new RegExp(respTabsId + "([0-9]+)"));

          if (matches !== null && matches.length === 2) {
            tabNum = parseInt(matches[1], 10) - 1;

            if (tabNum > count) {
              tabNum = 0;
            }
          }
        } //Active correct tab


        $($respTabs.find('.resp-tab-item')[tabNum]).addClass('resp-tab-active'); //keep closed if option = 'closed' or option is 'accordion' and the element is in accordion mode

        if (options.closed !== true && !(options.closed === 'accordion' && !$respTabsList.is(':visible')) && !(options.closed === 'tabs' && $respTabsList.is(':visible'))) {
          $($respTabs.find('.resp-accordion')[tabNum]).addClass('resp-tab-active');
          $($respTabs.find('.resp-tab-content')[tabNum]).addClass('resp-tab-content-active').attr('style', 'display:block');
        } //assign proper classes for when tabs mode is activated before making a selection in accordion mode
        else {
            $($respTabs.find('.resp-tab-content')[tabNum]).addClass('resp-tab-content-active resp-accordion-closed');
          } //Tab Click action function


        $respTabs.find("[role=tab]").each(function () {
          var $currentTab = $(this);
          $currentTab.click(function () {
            var $currentTab = $(this);
            var $tabAria = $currentTab.attr('aria-controls');

            if ($currentTab.hasClass('resp-accordion') && $currentTab.hasClass('resp-tab-active')) {
              $respTabs.find('.resp-tab-content-active').slideUp('', function () {
                $(this).addClass('resp-accordion-closed');
              });
              $currentTab.removeClass('resp-tab-active');
              return false;
            }

            if (!$currentTab.hasClass('resp-tab-active') && $currentTab.hasClass('resp-accordion')) {
              $respTabs.find('.resp-tab-active').removeClass('resp-tab-active');
              $respTabs.find('.resp-tab-content-active').slideUp().removeClass('resp-tab-content-active resp-accordion-closed');
              $respTabs.find("[aria-controls=" + $tabAria + "]").addClass('resp-tab-active');
              $respTabs.find('.resp-tab-content[aria-labelledby = ' + $tabAria + ']').slideDown().addClass('resp-tab-content-active');
            } else {
              $respTabs.find('.resp-tab-active').removeClass('resp-tab-active');
              $respTabs.find('.resp-tab-content-active').removeAttr('style').removeClass('resp-tab-content-active').removeClass('resp-accordion-closed');
              $respTabs.find("[aria-controls=" + $tabAria + "]").addClass('resp-tab-active');
              $respTabs.find('.resp-tab-content[aria-labelledby = ' + $tabAria + ']').addClass('resp-tab-content-active').attr('style', 'display:block');
            } //Trigger tab activation event


            $currentTab.trigger('tabactivate', $currentTab); //Update Browser History

            if (historyApi) {
              var currentHash = window.location.hash;
              var newHash = respTabsId + (parseInt($tabAria.substring(9), 10) + 1).toString();
              console.log(newHash);

              if (currentHash != "") {
                var re = new RegExp(respTabsId + "[0-9]+");

                if (currentHash.match(re) != null) {
                  newHash = currentHash.replace(re, newHash);
                } else {
                  newHash = currentHash + "|" + newHash;
                }
              } else {
                newHash = '#' + newHash;
              }

              history.replaceState(null, null, newHash);
            }
          });
        }); //Window resize function                   

        $(window).resize(function () {
          $respTabs.find('.resp-accordion-closed').removeAttr('style');
        });
      });
    }
  });
})(jQuery);

},{}],3:[function(require,module,exports){
"use strict";

/*
 * jQuery.appear
 * https://github.com/bas2k/jquery.appear/
 * http://code.google.com/p/jquery-appear/
 * http://bas2k.ru/
 *
 * Copyright (c) 2009 Michael Hixson
 * Copyright (c) 2012-2014 Alexander Brovikov
 * Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php)
 */
(function ($) {
  $.fn.appear = function (fn, options) {
    var settings = $.extend({
      //arbitrary data to pass to fn
      data: undefined,
      //call fn only on the first appear?
      one: true,
      // X & Y accuracy
      accX: 0,
      accY: 0
    }, options);
    return this.each(function () {
      var t = $(this); //whether the element is currently visible

      t.appeared = false;

      if (!fn) {
        //trigger the custom event
        t.trigger('appear', settings.data);
        return;
      }

      var w = $(window); //fires the appear event when appropriate

      var check = function check() {
        //is the element hidden?
        if (!t.is(':visible')) {
          //it became hidden
          t.appeared = false;
          return;
        } //is the element inside the visible window?


        var a = w.scrollLeft();
        var b = w.scrollTop();
        var o = t.offset();
        var x = o.left;
        var y = o.top;
        var ax = settings.accX;
        var ay = settings.accY;
        var th = t.height();
        var wh = w.height();
        var tw = t.width();
        var ww = w.width();

        if (y + th + ay >= b && y <= b + wh + ay && x + tw + ax >= a && x <= a + ww + ax) {
          //trigger the custom event
          if (!t.appeared) t.trigger('appear', settings.data);
        } else {
          //it scrolled out of view
          t.appeared = false;
        }
      }; //create a modified fn with some additional logic


      var modifiedFn = function modifiedFn() {
        //mark the element as visible
        t.appeared = true; //is this supposed to happen only once?

        if (settings.one) {
          //remove the check
          w.unbind('scroll', check);
          var i = $.inArray(check, $.fn.appear.checks);
          if (i >= 0) $.fn.appear.checks.splice(i, 1);
        } //trigger the original fn


        fn.apply(this, arguments);
      }; //bind the modified fn to the element


      if (settings.one) t.one('appear', settings.data, modifiedFn);else t.bind('appear', settings.data, modifiedFn); //check whenever the window scrolls

      w.scroll(check); //check whenever the dom changes

      $.fn.appear.checks.push(check); //check now

      check();
    });
  }; //keep a queue of appearance checks


  $.extend($.fn.appear, {
    checks: [],
    timeout: null,
    //process the queue
    checkAll: function checkAll() {
      var length = $.fn.appear.checks.length;
      if (length > 0) while (length--) {
        $.fn.appear.checks[length]();
      }
    },
    //check the queue asynchronously
    run: function run() {
      if ($.fn.appear.timeout) clearTimeout($.fn.appear.timeout);
      $.fn.appear.timeout = setTimeout($.fn.appear.checkAll, 20);
    }
  }); //run checks when these methods are called

  $.each(['append', 'prepend', 'after', 'before', 'attr', 'removeAttr', 'addClass', 'removeClass', 'toggleClass', 'remove', 'css', 'show', 'hide'], function (i, n) {
    var old = $.fn[n];

    if (old) {
      $.fn[n] = function () {
        var r = old.apply(this, arguments);
        $.fn.appear.run();
        return r;
      };
    }
  });
})(jQuery);

},{}],4:[function(require,module,exports){
"use strict";

(function ($) {
  $.fn.countTo = function (options) {
    options = options || {};
    return $(this).each(function () {
      // set options for current element
      var settings = $.extend({}, $.fn.countTo.defaults, {
        from: $(this).data('from'),
        to: $(this).data('to'),
        speed: $(this).data('speed'),
        refreshInterval: $(this).data('refresh-interval'),
        decimals: $(this).data('decimals')
      }, options); // how many times to update the value, and how much to increment the value on each update

      var loops = Math.ceil(settings.speed / settings.refreshInterval),
          increment = (settings.to - settings.from) / loops; // references & variables that will change with each update

      var self = this,
          $self = $(this),
          loopCount = 0,
          value = settings.from,
          data = $self.data('countTo') || {};
      $self.data('countTo', data); // if an existing interval can be found, clear it first

      if (data.interval) {
        clearInterval(data.interval);
      }

      data.interval = setInterval(updateTimer, settings.refreshInterval); // initialize the element with the starting value

      render(value);

      function updateTimer() {
        value += increment;
        loopCount++;
        render(value);

        if (typeof settings.onUpdate == 'function') {
          settings.onUpdate.call(self, value);
        }

        if (loopCount >= loops) {
          // remove the interval
          $self.removeData('countTo');
          clearInterval(data.interval);
          value = settings.to;

          if (typeof settings.onComplete == 'function') {
            settings.onComplete.call(self, value);
          }
        }
      }

      function render(value) {
        var formattedValue = settings.formatter.call(self, value, settings);
        $self.text(formattedValue);
      }
    });
  };

  $.fn.countTo.defaults = {
    from: 0,
    // the number the element should start at
    to: 0,
    // the number the element should end at
    speed: 1000,
    // how long it should take to count between the target numbers
    refreshInterval: 100,
    // how often the element should be updated
    decimals: 0,
    // the number of decimal places to show
    formatter: formatter,
    // handler for formatting the value before rendering
    onUpdate: null,
    // callback method for every time the element is updated
    onComplete: null // callback method for when the element finishes updating

  };

  function formatter(value, settings) {
    return value.toFixed(settings.decimals);
  }
})(jQuery);

},{}],5:[function(require,module,exports){
"use strict";

/*!
 * The Final Countdown for jQuery v2.0.4 (http://hilios.github.io/jQuery.countdown/)
 * Copyright (c) 2014 Edson Hilios
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
(function (factory) {
  "use strict";

  if (typeof define === "function" && define.amd) {
    define(["jquery"], factory);
  } else {
    factory(jQuery);
  }
})(function ($) {
  "use strict";

  var PRECISION = 100;
  var instances = [],
      matchers = [];
  matchers.push(/^[0-9]*$/.source);
  matchers.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source);
  matchers.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source);
  matchers = new RegExp(matchers.join("|"));

  function parseDateString(dateString) {
    if (dateString instanceof Date) {
      return dateString;
    }

    if (String(dateString).match(matchers)) {
      if (String(dateString).match(/^[0-9]*$/)) {
        dateString = Number(dateString);
      }

      if (String(dateString).match(/\-/)) {
        dateString = String(dateString).replace(/\-/g, "/");
      }

      return new Date(dateString);
    } else {
      throw new Error("Couldn't cast `" + dateString + "` to a date object.");
    }
  }

  var DIRECTIVE_KEY_MAP = {
    Y: "years",
    m: "months",
    w: "weeks",
    d: "days",
    D: "totalDays",
    H: "hours",
    M: "minutes",
    S: "seconds"
  };

  function strftime(offsetObject) {
    return function (format) {
      var directives = format.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);

      if (directives) {
        for (var i = 0, len = directives.length; i < len; ++i) {
          var directive = directives[i].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),
              regexp = new RegExp(directive[0]),
              modifier = directive[1] || "",
              plural = directive[3] || "",
              value = null;
          directive = directive[2];

          if (DIRECTIVE_KEY_MAP.hasOwnProperty(directive)) {
            value = DIRECTIVE_KEY_MAP[directive];
            value = Number(offsetObject[value]);
          }

          if (value !== null) {
            if (modifier === "!") {
              value = pluralize(plural, value);
            }

            if (modifier === "") {
              if (value < 10) {
                value = "0" + value.toString();
              }
            }

            format = format.replace(regexp, value.toString());
          }
        }
      }

      format = format.replace(/%%/, "%");
      return format;
    };
  }

  function pluralize(format, count) {
    var plural = "s",
        singular = "";

    if (format) {
      format = format.replace(/(:|;|\s)/gi, "").split(/\,/);

      if (format.length === 1) {
        plural = format[0];
      } else {
        singular = format[0];
        plural = format[1];
      }
    }

    if (Math.abs(count) === 1) {
      return singular;
    } else {
      return plural;
    }
  }

  var Countdown = function Countdown(el, finalDate, callback) {
    this.el = el;
    this.$el = $(el);
    this.interval = null;
    this.offset = {};
    this.instanceNumber = instances.length;
    instances.push(this);
    this.$el.data("countdown-instance", this.instanceNumber);

    if (callback) {
      this.$el.on("update.countdown", callback);
      this.$el.on("stoped.countdown", callback);
      this.$el.on("finish.countdown", callback);
    }

    this.setFinalDate(finalDate);
    this.start();
  };

  $.extend(Countdown.prototype, {
    start: function start() {
      if (this.interval !== null) {
        clearInterval(this.interval);
      }

      var self = this;
      this.update();
      this.interval = setInterval(function () {
        self.update.call(self);
      }, PRECISION);
    },
    stop: function stop() {
      clearInterval(this.interval);
      this.interval = null;
      this.dispatchEvent("stoped");
    },
    pause: function pause() {
      this.stop.call(this);
    },
    resume: function resume() {
      this.start.call(this);
    },
    remove: function remove() {
      this.stop();
      instances[this.instanceNumber] = null;
      delete this.$el.data().countdownInstance;
    },
    setFinalDate: function setFinalDate(value) {
      this.finalDate = parseDateString(value);
    },
    update: function update() {
      if (this.$el.closest("html").length === 0) {
        this.remove();
        return;
      }

      this.totalSecsLeft = this.finalDate.getTime() - new Date().getTime();
      this.totalSecsLeft = Math.ceil(this.totalSecsLeft / 1e3);
      this.totalSecsLeft = this.totalSecsLeft < 0 ? 0 : this.totalSecsLeft;
      this.offset = {
        seconds: this.totalSecsLeft % 60,
        minutes: Math.floor(this.totalSecsLeft / 60) % 60,
        hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
        days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
        totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
        weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
        months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30),
        years: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 365)
      };

      if (this.totalSecsLeft === 0) {
        this.stop();
        this.dispatchEvent("finish");
      } else {
        this.dispatchEvent("update");
      }
    },
    dispatchEvent: function dispatchEvent(eventName) {
      var event = $.Event(eventName + ".countdown");
      event.finalDate = this.finalDate;
      event.offset = $.extend({}, this.offset);
      event.strftime = strftime(this.offset);
      this.$el.trigger(event);
    }
  });

  $.fn.countdown = function () {
    var argumentsArray = Array.prototype.slice.call(arguments, 0);
    return this.each(function () {
      var instanceNumber = $(this).data("countdown-instance");

      if (instanceNumber !== undefined) {
        var instance = instances[instanceNumber],
            method = argumentsArray[0];

        if (Countdown.prototype.hasOwnProperty(method)) {
          instance[method].apply(instance, argumentsArray.slice(1));
        } else if (String(method).match(/^[$A-Z_][0-9A-Z_$]*$/i) === null) {
          instance.setFinalDate.call(instance, method);
          instance.start();
        } else {
          $.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi, method));
        }
      } else {
        new Countdown(this, argumentsArray[0], argumentsArray[1]);
      }
    });
  };
});

},{}],6:[function(require,module,exports){
"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj === "undefined" ? "undefined" : _typeof(obj); }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj); }); } return _typeof(obj); }

/*
 *  jQuery OwlCarousel v1.3.2
 *
 *  Copyright (c) 2013 Bartosz Wojciechowski
 *  http://www.owlgraphic.com/owlcarousel/
 *
 *  Licensed under MIT
 *
 */

/*JS Lint helpers: */

/*global dragMove: false, dragEnd: false, $, jQuery, alert, window, document */

/*jslint nomen: true, continue:true */
if (typeof Object.create !== "function") {
  Object.create = function (obj) {
    function F() {}

    F.prototype = obj;
    return new F();
  };
}

(function ($, window, document) {
  var Carousel = {
    init: function init(options, el) {
      var base = this;
      base.$elem = $(el);
      base.options = $.extend({}, $.fn.owlCarousel.options, base.$elem.data(), options);
      base.userOptions = options;
      base.loadContent();
    },
    loadContent: function loadContent() {
      var base = this,
          url;

      function getData(data) {
        var i,
            content = "";

        if (typeof base.options.jsonSuccess === "function") {
          base.options.jsonSuccess.apply(this, [data]);
        } else {
          for (i in data.owl) {
            if (data.owl.hasOwnProperty(i)) {
              content += data.owl[i].item;
            }
          }

          base.$elem.html(content);
        }

        base.logIn();
      }

      if (typeof base.options.beforeInit === "function") {
        base.options.beforeInit.apply(this, [base.$elem]);
      }

      if (typeof base.options.jsonPath === "string") {
        url = base.options.jsonPath;
        $.getJSON(url, getData);
      } else {
        base.logIn();
      }
    },
    logIn: function logIn() {
      var base = this;
      base.$elem.data("owl-originalStyles", base.$elem.attr("style")).data("owl-originalClasses", base.$elem.attr("class"));
      base.$elem.css({
        opacity: 0
      });
      base.orignalItems = base.options.items;
      base.checkBrowser();
      base.wrapperWidth = 0;
      base.checkVisible = null;
      base.setVars();
    },
    setVars: function setVars() {
      var base = this;

      if (base.$elem.children().length === 0) {
        return false;
      }

      base.baseClass();
      base.eventTypes();
      base.$userItems = base.$elem.children();
      base.itemsAmount = base.$userItems.length;
      base.wrapItems();
      base.$owlItems = base.$elem.find(".owl-item");
      base.$owlWrapper = base.$elem.find(".owl-wrapper");
      base.playDirection = "next";
      base.prevItem = 0;
      base.prevArr = [0];
      base.currentItem = 0;
      base.customEvents();
      base.onStartup();
    },
    onStartup: function onStartup() {
      var base = this;
      base.updateItems();
      base.calculateAll();
      base.buildControls();
      base.updateControls();
      base.response();
      base.moveEvents();
      base.stopOnHover();
      base.owlStatus();

      if (base.options.transitionStyle !== false) {
        base.transitionTypes(base.options.transitionStyle);
      }

      if (base.options.autoPlay === true) {
        base.options.autoPlay = 5000;
      }

      base.play();
      base.$elem.find(".owl-wrapper").css("display", "block");

      if (!base.$elem.is(":visible")) {
        base.watchVisibility();
      } else {
        base.$elem.css("opacity", 1);
      }

      base.onstartup = false;
      base.eachMoveUpdate();

      if (typeof base.options.afterInit === "function") {
        base.options.afterInit.apply(this, [base.$elem]);
      }
    },
    eachMoveUpdate: function eachMoveUpdate() {
      var base = this;

      if (base.options.lazyLoad === true) {
        base.lazyLoad();
      }

      if (base.options.autoHeight === true) {
        base.autoHeight();
      }

      base.onVisibleItems();

      if (typeof base.options.afterAction === "function") {
        base.options.afterAction.apply(this, [base.$elem]);
      }
    },
    updateVars: function updateVars() {
      var base = this;

      if (typeof base.options.beforeUpdate === "function") {
        base.options.beforeUpdate.apply(this, [base.$elem]);
      }

      base.watchVisibility();
      base.updateItems();
      base.calculateAll();
      base.updatePosition();
      base.updateControls();
      base.eachMoveUpdate();

      if (typeof base.options.afterUpdate === "function") {
        base.options.afterUpdate.apply(this, [base.$elem]);
      }
    },
    reload: function reload() {
      var base = this;
      window.setTimeout(function () {
        base.updateVars();
      }, 0);
    },
    watchVisibility: function watchVisibility() {
      var base = this;

      if (base.$elem.is(":visible") === false) {
        base.$elem.css({
          opacity: 0
        });
        window.clearInterval(base.autoPlayInterval);
        window.clearInterval(base.checkVisible);
      } else {
        return false;
      }

      base.checkVisible = window.setInterval(function () {
        if (base.$elem.is(":visible")) {
          base.reload();
          base.$elem.animate({
            opacity: 1
          }, 200);
          window.clearInterval(base.checkVisible);
        }
      }, 500);
    },
    wrapItems: function wrapItems() {
      var base = this;
      base.$userItems.wrapAll("<div class=\"owl-wrapper\">").wrap("<div class=\"owl-item\"></div>");
      base.$elem.find(".owl-wrapper").wrap("<div class=\"owl-wrapper-outer\">");
      base.wrapperOuter = base.$elem.find(".owl-wrapper-outer");
      base.$elem.css("display", "block");
    },
    baseClass: function baseClass() {
      var base = this,
          hasBaseClass = base.$elem.hasClass(base.options.baseClass),
          hasThemeClass = base.$elem.hasClass(base.options.theme);

      if (!hasBaseClass) {
        base.$elem.addClass(base.options.baseClass);
      }

      if (!hasThemeClass) {
        base.$elem.addClass(base.options.theme);
      }
    },
    updateItems: function updateItems() {
      var base = this,
          width,
          i;

      if (base.options.responsive === false) {
        return false;
      }

      if (base.options.singleItem === true) {
        base.options.items = base.orignalItems = 1;
        base.options.itemsCustom = false;
        base.options.itemsDesktop = false;
        base.options.itemsDesktopSmall = false;
        base.options.itemsTablet = false;
        base.options.itemsTabletSmall = false;
        base.options.itemsMobile = false;
        return false;
      }

      width = $(base.options.responsiveBaseWidth).width();

      if (width > (base.options.itemsDesktop[0] || base.orignalItems)) {
        base.options.items = base.orignalItems;
      }

      if (base.options.itemsCustom !== false) {
        //Reorder array by screen size
        base.options.itemsCustom.sort(function (a, b) {
          return a[0] - b[0];
        });

        for (i = 0; i < base.options.itemsCustom.length; i += 1) {
          if (base.options.itemsCustom[i][0] <= width) {
            base.options.items = base.options.itemsCustom[i][1];
          }
        }
      } else {
        if (width <= base.options.itemsDesktop[0] && base.options.itemsDesktop !== false) {
          base.options.items = base.options.itemsDesktop[1];
        }

        if (width <= base.options.itemsDesktopSmall[0] && base.options.itemsDesktopSmall !== false) {
          base.options.items = base.options.itemsDesktopSmall[1];
        }

        if (width <= base.options.itemsTablet[0] && base.options.itemsTablet !== false) {
          base.options.items = base.options.itemsTablet[1];
        }

        if (width <= base.options.itemsTabletSmall[0] && base.options.itemsTabletSmall !== false) {
          base.options.items = base.options.itemsTabletSmall[1];
        }

        if (width <= base.options.itemsMobile[0] && base.options.itemsMobile !== false) {
          base.options.items = base.options.itemsMobile[1];
        }
      } //if number of items is less than declared


      if (base.options.items > base.itemsAmount && base.options.itemsScaleUp === true) {
        base.options.items = base.itemsAmount;
      }
    },
    response: function response() {
      var base = this,
          smallDelay,
          lastWindowWidth;

      if (base.options.responsive !== true) {
        return false;
      }

      lastWindowWidth = $(window).width();

      base.resizer = function () {
        if ($(window).width() !== lastWindowWidth) {
          if (base.options.autoPlay !== false) {
            window.clearInterval(base.autoPlayInterval);
          }

          window.clearTimeout(smallDelay);
          smallDelay = window.setTimeout(function () {
            lastWindowWidth = $(window).width();
            base.updateVars();
          }, base.options.responsiveRefreshRate);
        }
      };

      $(window).resize(base.resizer);
    },
    updatePosition: function updatePosition() {
      var base = this;
      base.jumpTo(base.currentItem);

      if (base.options.autoPlay !== false) {
        base.checkAp();
      }
    },
    appendItemsSizes: function appendItemsSizes() {
      var base = this,
          roundPages = 0,
          lastItem = base.itemsAmount - base.options.items;
      base.$owlItems.each(function (index) {
        var $this = $(this);
        $this.css({
          "width": base.itemWidth
        }).data("owl-item", Number(index));

        if (index % base.options.items === 0 || index === lastItem) {
          if (!(index > lastItem)) {
            roundPages += 1;
          }
        }

        $this.data("owl-roundPages", roundPages);
      });
    },
    appendWrapperSizes: function appendWrapperSizes() {
      var base = this,
          width = base.$owlItems.length * base.itemWidth;
      base.$owlWrapper.css({
        "width": width * 2,
        "left": 0
      });
      base.appendItemsSizes();
    },
    calculateAll: function calculateAll() {
      var base = this;
      base.calculateWidth();
      base.appendWrapperSizes();
      base.loops();
      base.max();
    },
    calculateWidth: function calculateWidth() {
      var base = this;
      base.itemWidth = Math.round(base.$elem.width() / base.options.items);
    },
    max: function max() {
      var base = this,
          maximum = (base.itemsAmount * base.itemWidth - base.options.items * base.itemWidth) * -1;

      if (base.options.items > base.itemsAmount) {
        base.maximumItem = 0;
        maximum = 0;
        base.maximumPixels = 0;
      } else {
        base.maximumItem = base.itemsAmount - base.options.items;
        base.maximumPixels = maximum;
      }

      return maximum;
    },
    min: function min() {
      return 0;
    },
    loops: function loops() {
      var base = this,
          prev = 0,
          elWidth = 0,
          i,
          item,
          roundPageNum;
      base.positionsInArray = [0];
      base.pagesInArray = [];

      for (i = 0; i < base.itemsAmount; i += 1) {
        elWidth += base.itemWidth;
        base.positionsInArray.push(-elWidth);

        if (base.options.scrollPerPage === true) {
          item = $(base.$owlItems[i]);
          roundPageNum = item.data("owl-roundPages");

          if (roundPageNum !== prev) {
            base.pagesInArray[prev] = base.positionsInArray[i];
            prev = roundPageNum;
          }
        }
      }
    },
    buildControls: function buildControls() {
      var base = this;

      if (base.options.navigation === true || base.options.pagination === true) {
        base.owlControls = $("<div class=\"owl-controls\"/>").toggleClass("clickable", !base.browser.isTouch).appendTo(base.$elem);
      }

      if (base.options.pagination === true) {
        base.buildPagination();
      }

      if (base.options.navigation === true) {
        base.buildButtons();
      }
    },
    buildButtons: function buildButtons() {
      var base = this,
          buttonsWrapper = $("<div class=\"owl-buttons\"/>");
      base.owlControls.append(buttonsWrapper);
      base.buttonPrev = $("<div/>", {
        "class": "owl-prev",
        "html": base.options.navigationText[0] || ""
      });
      base.buttonNext = $("<div/>", {
        "class": "owl-next",
        "html": base.options.navigationText[1] || ""
      });
      buttonsWrapper.append(base.buttonPrev).append(base.buttonNext);
      buttonsWrapper.on("touchstart.owlControls mousedown.owlControls", "div[class^=\"owl\"]", function (event) {
        event.preventDefault();
      });
      buttonsWrapper.on("touchend.owlControls mouseup.owlControls", "div[class^=\"owl\"]", function (event) {
        event.preventDefault();

        if ($(this).hasClass("owl-next")) {
          base.next();
        } else {
          base.prev();
        }
      });
    },
    buildPagination: function buildPagination() {
      var base = this;
      base.paginationWrapper = $("<div class=\"owl-pagination\"/>");
      base.owlControls.append(base.paginationWrapper);
      base.paginationWrapper.on("touchend.owlControls mouseup.owlControls", ".owl-page", function (event) {
        event.preventDefault();

        if (Number($(this).data("owl-page")) !== base.currentItem) {
          base.goTo(Number($(this).data("owl-page")), true);
        }
      });
    },
    updatePagination: function updatePagination() {
      var base = this,
          counter,
          lastPage,
          lastItem,
          i,
          paginationButton,
          paginationButtonInner;

      if (base.options.pagination === false) {
        return false;
      }

      base.paginationWrapper.html("");
      counter = 0;
      lastPage = base.itemsAmount - base.itemsAmount % base.options.items;

      for (i = 0; i < base.itemsAmount; i += 1) {
        if (i % base.options.items === 0) {
          counter += 1;

          if (lastPage === i) {
            lastItem = base.itemsAmount - base.options.items;
          }

          paginationButton = $("<div/>", {
            "class": "owl-page"
          });
          paginationButtonInner = $("<span></span>", {
            "text": base.options.paginationNumbers === true ? counter : "",
            "class": base.options.paginationNumbers === true ? "owl-numbers" : ""
          });
          paginationButton.append(paginationButtonInner);
          paginationButton.data("owl-page", lastPage === i ? lastItem : i);
          paginationButton.data("owl-roundPages", counter);
          base.paginationWrapper.append(paginationButton);
        }
      }

      base.checkPagination();
    },
    checkPagination: function checkPagination() {
      var base = this;

      if (base.options.pagination === false) {
        return false;
      }

      base.paginationWrapper.find(".owl-page").each(function () {
        if ($(this).data("owl-roundPages") === $(base.$owlItems[base.currentItem]).data("owl-roundPages")) {
          base.paginationWrapper.find(".owl-page").removeClass("active");
          $(this).addClass("active");
        }
      });
    },
    checkNavigation: function checkNavigation() {
      var base = this;

      if (base.options.navigation === false) {
        return false;
      }

      if (base.options.rewindNav === false) {
        if (base.currentItem === 0 && base.maximumItem === 0) {
          base.buttonPrev.addClass("disabled");
          base.buttonNext.addClass("disabled");
        } else if (base.currentItem === 0 && base.maximumItem !== 0) {
          base.buttonPrev.addClass("disabled");
          base.buttonNext.removeClass("disabled");
        } else if (base.currentItem === base.maximumItem) {
          base.buttonPrev.removeClass("disabled");
          base.buttonNext.addClass("disabled");
        } else if (base.currentItem !== 0 && base.currentItem !== base.maximumItem) {
          base.buttonPrev.removeClass("disabled");
          base.buttonNext.removeClass("disabled");
        }
      }
    },
    updateControls: function updateControls() {
      var base = this;
      base.updatePagination();
      base.checkNavigation();

      if (base.owlControls) {
        if (base.options.items >= base.itemsAmount) {
          base.owlControls.hide();
        } else {
          base.owlControls.show();
        }
      }
    },
    destroyControls: function destroyControls() {
      var base = this;

      if (base.owlControls) {
        base.owlControls.remove();
      }
    },
    next: function next(speed) {
      var base = this;

      if (base.isTransition) {
        return false;
      }

      base.currentItem += base.options.scrollPerPage === true ? base.options.items : 1;

      if (base.currentItem > base.maximumItem + (base.options.scrollPerPage === true ? base.options.items - 1 : 0)) {
        if (base.options.rewindNav === true) {
          base.currentItem = 0;
          speed = "rewind";
        } else {
          base.currentItem = base.maximumItem;
          return false;
        }
      }

      base.goTo(base.currentItem, speed);
    },
    prev: function prev(speed) {
      var base = this;

      if (base.isTransition) {
        return false;
      }

      if (base.options.scrollPerPage === true && base.currentItem > 0 && base.currentItem < base.options.items) {
        base.currentItem = 0;
      } else {
        base.currentItem -= base.options.scrollPerPage === true ? base.options.items : 1;
      }

      if (base.currentItem < 0) {
        if (base.options.rewindNav === true) {
          base.currentItem = base.maximumItem;
          speed = "rewind";
        } else {
          base.currentItem = 0;
          return false;
        }
      }

      base.goTo(base.currentItem, speed);
    },
    goTo: function goTo(position, speed, drag) {
      var base = this,
          goToPixel;

      if (base.isTransition) {
        return false;
      }

      if (typeof base.options.beforeMove === "function") {
        base.options.beforeMove.apply(this, [base.$elem]);
      }

      if (position >= base.maximumItem) {
        position = base.maximumItem;
      } else if (position <= 0) {
        position = 0;
      }

      base.currentItem = base.owl.currentItem = position;

      if (base.options.transitionStyle !== false && drag !== "drag" && base.options.items === 1 && base.browser.support3d === true) {
        base.swapSpeed(0);

        if (base.browser.support3d === true) {
          base.transition3d(base.positionsInArray[position]);
        } else {
          base.css2slide(base.positionsInArray[position], 1);
        }

        base.afterGo();
        base.singleItemTransition();
        return false;
      }

      goToPixel = base.positionsInArray[position];

      if (base.browser.support3d === true) {
        base.isCss3Finish = false;

        if (speed === true) {
          base.swapSpeed("paginationSpeed");
          window.setTimeout(function () {
            base.isCss3Finish = true;
          }, base.options.paginationSpeed);
        } else if (speed === "rewind") {
          base.swapSpeed(base.options.rewindSpeed);
          window.setTimeout(function () {
            base.isCss3Finish = true;
          }, base.options.rewindSpeed);
        } else {
          base.swapSpeed("slideSpeed");
          window.setTimeout(function () {
            base.isCss3Finish = true;
          }, base.options.slideSpeed);
        }

        base.transition3d(goToPixel);
      } else {
        if (speed === true) {
          base.css2slide(goToPixel, base.options.paginationSpeed);
        } else if (speed === "rewind") {
          base.css2slide(goToPixel, base.options.rewindSpeed);
        } else {
          base.css2slide(goToPixel, base.options.slideSpeed);
        }
      }

      base.afterGo();
    },
    jumpTo: function jumpTo(position) {
      var base = this;

      if (typeof base.options.beforeMove === "function") {
        base.options.beforeMove.apply(this, [base.$elem]);
      }

      if (position >= base.maximumItem || position === -1) {
        position = base.maximumItem;
      } else if (position <= 0) {
        position = 0;
      }

      base.swapSpeed(0);

      if (base.browser.support3d === true) {
        base.transition3d(base.positionsInArray[position]);
      } else {
        base.css2slide(base.positionsInArray[position], 1);
      }

      base.currentItem = base.owl.currentItem = position;
      base.afterGo();
    },
    afterGo: function afterGo() {
      var base = this;
      base.prevArr.push(base.currentItem);
      base.prevItem = base.owl.prevItem = base.prevArr[base.prevArr.length - 2];
      base.prevArr.shift(0);

      if (base.prevItem !== base.currentItem) {
        base.checkPagination();
        base.checkNavigation();
        base.eachMoveUpdate();

        if (base.options.autoPlay !== false) {
          base.checkAp();
        }
      }

      if (typeof base.options.afterMove === "function" && base.prevItem !== base.currentItem) {
        base.options.afterMove.apply(this, [base.$elem]);
      }
    },
    stop: function stop() {
      var base = this;
      base.apStatus = "stop";
      window.clearInterval(base.autoPlayInterval);
    },
    checkAp: function checkAp() {
      var base = this;

      if (base.apStatus !== "stop") {
        base.play();
      }
    },
    play: function play() {
      var base = this;
      base.apStatus = "play";

      if (base.options.autoPlay === false) {
        return false;
      }

      window.clearInterval(base.autoPlayInterval);
      base.autoPlayInterval = window.setInterval(function () {
        base.next(true);
      }, base.options.autoPlay);
    },
    swapSpeed: function swapSpeed(action) {
      var base = this;

      if (action === "slideSpeed") {
        base.$owlWrapper.css(base.addCssSpeed(base.options.slideSpeed));
      } else if (action === "paginationSpeed") {
        base.$owlWrapper.css(base.addCssSpeed(base.options.paginationSpeed));
      } else if (typeof action !== "string") {
        base.$owlWrapper.css(base.addCssSpeed(action));
      }
    },
    addCssSpeed: function addCssSpeed(speed) {
      return {
        "-webkit-transition": "all " + speed + "ms ease",
        "-moz-transition": "all " + speed + "ms ease",
        "-o-transition": "all " + speed + "ms ease",
        "transition": "all " + speed + "ms ease"
      };
    },
    removeTransition: function removeTransition() {
      return {
        "-webkit-transition": "",
        "-moz-transition": "",
        "-o-transition": "",
        "transition": ""
      };
    },
    doTranslate: function doTranslate(pixels) {
      return {
        "-webkit-transform": "translate3d(" + pixels + "px, 0px, 0px)",
        "-moz-transform": "translate3d(" + pixels + "px, 0px, 0px)",
        "-o-transform": "translate3d(" + pixels + "px, 0px, 0px)",
        "-ms-transform": "translate3d(" + pixels + "px, 0px, 0px)",
        "transform": "translate3d(" + pixels + "px, 0px,0px)"
      };
    },
    transition3d: function transition3d(value) {
      var base = this;
      base.$owlWrapper.css(base.doTranslate(value));
    },
    css2move: function css2move(value) {
      var base = this;
      base.$owlWrapper.css({
        "left": value
      });
    },
    css2slide: function css2slide(value, speed) {
      var base = this;
      base.isCssFinish = false;
      base.$owlWrapper.stop(true, true).animate({
        "left": value
      }, {
        duration: speed || base.options.slideSpeed,
        complete: function complete() {
          base.isCssFinish = true;
        }
      });
    },
    checkBrowser: function checkBrowser() {
      var base = this,
          translate3D = "translate3d(0px, 0px, 0px)",
          tempElem = document.createElement("div"),
          regex,
          asSupport,
          support3d,
          isTouch;
      tempElem.style.cssText = "  -moz-transform:" + translate3D + "; -ms-transform:" + translate3D + "; -o-transform:" + translate3D + "; -webkit-transform:" + translate3D + "; transform:" + translate3D;
      regex = /translate3d\(0px, 0px, 0px\)/g;
      asSupport = tempElem.style.cssText.match(regex);
      support3d = asSupport !== null && asSupport.length === 1;
      isTouch = "ontouchstart" in window || window.navigator.msMaxTouchPoints;
      base.browser = {
        "support3d": support3d,
        "isTouch": isTouch
      };
    },
    moveEvents: function moveEvents() {
      var base = this;

      if (base.options.mouseDrag !== false || base.options.touchDrag !== false) {
        base.gestures();
        base.disabledEvents();
      }
    },
    eventTypes: function eventTypes() {
      var base = this,
          types = ["s", "e", "x"];
      base.ev_types = {};

      if (base.options.mouseDrag === true && base.options.touchDrag === true) {
        types = ["touchstart.owl mousedown.owl", "touchmove.owl mousemove.owl", "touchend.owl touchcancel.owl mouseup.owl"];
      } else if (base.options.mouseDrag === false && base.options.touchDrag === true) {
        types = ["touchstart.owl", "touchmove.owl", "touchend.owl touchcancel.owl"];
      } else if (base.options.mouseDrag === true && base.options.touchDrag === false) {
        types = ["mousedown.owl", "mousemove.owl", "mouseup.owl"];
      }

      base.ev_types.start = types[0];
      base.ev_types.move = types[1];
      base.ev_types.end = types[2];
    },
    disabledEvents: function disabledEvents() {
      var base = this;
      base.$elem.on("dragstart.owl", function (event) {
        event.preventDefault();
      });
      base.$elem.on("mousedown.disableTextSelect", function (e) {
        return $(e.target).is('input, textarea, select, option');
      });
    },
    gestures: function gestures() {
      /*jslint unparam: true*/
      var base = this,
          locals = {
        offsetX: 0,
        offsetY: 0,
        baseElWidth: 0,
        relativePos: 0,
        position: null,
        minSwipe: null,
        maxSwipe: null,
        sliding: null,
        dargging: null,
        targetElement: null
      };
      base.isCssFinish = true;

      function getTouches(event) {
        if (event.touches !== undefined) {
          return {
            x: event.touches[0].pageX,
            y: event.touches[0].pageY
          };
        }

        if (event.touches === undefined) {
          if (event.pageX !== undefined) {
            return {
              x: event.pageX,
              y: event.pageY
            };
          }

          if (event.pageX === undefined) {
            return {
              x: event.clientX,
              y: event.clientY
            };
          }
        }
      }

      function swapEvents(type) {
        if (type === "on") {
          $(document).on(base.ev_types.move, dragMove);
          $(document).on(base.ev_types.end, dragEnd);
        } else if (type === "off") {
          $(document).off(base.ev_types.move);
          $(document).off(base.ev_types.end);
        }
      }

      function dragStart(event) {
        var ev = event.originalEvent || event || window.event,
            position;

        if (ev.which === 3) {
          return false;
        }

        if (base.itemsAmount <= base.options.items) {
          return;
        }

        if (base.isCssFinish === false && !base.options.dragBeforeAnimFinish) {
          return false;
        }

        if (base.isCss3Finish === false && !base.options.dragBeforeAnimFinish) {
          return false;
        }

        if (base.options.autoPlay !== false) {
          window.clearInterval(base.autoPlayInterval);
        }

        if (base.browser.isTouch !== true && !base.$owlWrapper.hasClass("grabbing")) {
          base.$owlWrapper.addClass("grabbing");
        }

        base.newPosX = 0;
        base.newRelativeX = 0;
        $(this).css(base.removeTransition());
        position = $(this).position();
        locals.relativePos = position.left;
        locals.offsetX = getTouches(ev).x - position.left;
        locals.offsetY = getTouches(ev).y - position.top;
        swapEvents("on");
        locals.sliding = false;
        locals.targetElement = ev.target || ev.srcElement;
      }

      function dragMove(event) {
        var ev = event.originalEvent || event || window.event,
            minSwipe,
            maxSwipe;
        base.newPosX = getTouches(ev).x - locals.offsetX;
        base.newPosY = getTouches(ev).y - locals.offsetY;
        base.newRelativeX = base.newPosX - locals.relativePos;

        if (typeof base.options.startDragging === "function" && locals.dragging !== true && base.newRelativeX !== 0) {
          locals.dragging = true;
          base.options.startDragging.apply(base, [base.$elem]);
        }

        if ((base.newRelativeX > 8 || base.newRelativeX < -8) && base.browser.isTouch === true) {
          if (ev.preventDefault !== undefined) {
            ev.preventDefault();
          } else {
            ev.returnValue = false;
          }

          locals.sliding = true;
        }

        if ((base.newPosY > 10 || base.newPosY < -10) && locals.sliding === false) {
          $(document).off("touchmove.owl");
        }

        minSwipe = function minSwipe() {
          return base.newRelativeX / 5;
        };

        maxSwipe = function maxSwipe() {
          return base.maximumPixels + base.newRelativeX / 5;
        };

        base.newPosX = Math.max(Math.min(base.newPosX, minSwipe()), maxSwipe());

        if (base.browser.support3d === true) {
          base.transition3d(base.newPosX);
        } else {
          base.css2move(base.newPosX);
        }
      }

      function dragEnd(event) {
        var ev = event.originalEvent || event || window.event,
            newPosition,
            handlers,
            owlStopEvent;
        ev.target = ev.target || ev.srcElement;
        locals.dragging = false;

        if (base.browser.isTouch !== true) {
          base.$owlWrapper.removeClass("grabbing");
        }

        if (base.newRelativeX < 0) {
          base.dragDirection = base.owl.dragDirection = "left";
        } else {
          base.dragDirection = base.owl.dragDirection = "right";
        }

        if (base.newRelativeX !== 0) {
          newPosition = base.getNewPosition();
          base.goTo(newPosition, false, "drag");

          if (locals.targetElement === ev.target && base.browser.isTouch !== true) {
            $(ev.target).on("click.disable", function (ev) {
              ev.stopImmediatePropagation();
              ev.stopPropagation();
              ev.preventDefault();
              $(ev.target).off("click.disable");
            });
            handlers = $._data(ev.target, "events").click;
            owlStopEvent = handlers.pop();
            handlers.splice(0, 0, owlStopEvent);
          }
        }

        swapEvents("off");
      }

      base.$elem.on(base.ev_types.start, ".owl-wrapper", dragStart);
    },
    getNewPosition: function getNewPosition() {
      var base = this,
          newPosition = base.closestItem();

      if (newPosition > base.maximumItem) {
        base.currentItem = base.maximumItem;
        newPosition = base.maximumItem;
      } else if (base.newPosX >= 0) {
        newPosition = 0;
        base.currentItem = 0;
      }

      return newPosition;
    },
    closestItem: function closestItem() {
      var base = this,
          array = base.options.scrollPerPage === true ? base.pagesInArray : base.positionsInArray,
          goal = base.newPosX,
          closest = null;
      $.each(array, function (i, v) {
        if (goal - base.itemWidth / 20 > array[i + 1] && goal - base.itemWidth / 20 < v && base.moveDirection() === "left") {
          closest = v;

          if (base.options.scrollPerPage === true) {
            base.currentItem = $.inArray(closest, base.positionsInArray);
          } else {
            base.currentItem = i;
          }
        } else if (goal + base.itemWidth / 20 < v && goal + base.itemWidth / 20 > (array[i + 1] || array[i] - base.itemWidth) && base.moveDirection() === "right") {
          if (base.options.scrollPerPage === true) {
            closest = array[i + 1] || array[array.length - 1];
            base.currentItem = $.inArray(closest, base.positionsInArray);
          } else {
            closest = array[i + 1];
            base.currentItem = i + 1;
          }
        }
      });
      return base.currentItem;
    },
    moveDirection: function moveDirection() {
      var base = this,
          direction;

      if (base.newRelativeX < 0) {
        direction = "right";
        base.playDirection = "next";
      } else {
        direction = "left";
        base.playDirection = "prev";
      }

      return direction;
    },
    customEvents: function customEvents() {
      /*jslint unparam: true*/
      var base = this;
      base.$elem.on("owl.next", function () {
        base.next();
      });
      base.$elem.on("owl.prev", function () {
        base.prev();
      });
      base.$elem.on("owl.play", function (event, speed) {
        base.options.autoPlay = speed;
        base.play();
        base.hoverStatus = "play";
      });
      base.$elem.on("owl.stop", function () {
        base.stop();
        base.hoverStatus = "stop";
      });
      base.$elem.on("owl.goTo", function (event, item) {
        base.goTo(item);
      });
      base.$elem.on("owl.jumpTo", function (event, item) {
        base.jumpTo(item);
      });
    },
    stopOnHover: function stopOnHover() {
      var base = this;

      if (base.options.stopOnHover === true && base.browser.isTouch !== true && base.options.autoPlay !== false) {
        base.$elem.on("mouseover", function () {
          base.stop();
        });
        base.$elem.on("mouseout", function () {
          if (base.hoverStatus !== "stop") {
            base.play();
          }
        });
      }
    },
    lazyLoad: function lazyLoad() {
      var base = this,
          i,
          $item,
          itemNumber,
          $lazyImg,
          follow;

      if (base.options.lazyLoad === false) {
        return false;
      }

      for (i = 0; i < base.itemsAmount; i += 1) {
        $item = $(base.$owlItems[i]);

        if ($item.data("owl-loaded") === "loaded") {
          continue;
        }

        itemNumber = $item.data("owl-item");
        $lazyImg = $item.find(".lazyOwl");

        if (typeof $lazyImg.data("src") !== "string") {
          $item.data("owl-loaded", "loaded");
          continue;
        }

        if ($item.data("owl-loaded") === undefined) {
          $lazyImg.hide();
          $item.addClass("loading").data("owl-loaded", "checked");
        }

        if (base.options.lazyFollow === true) {
          follow = itemNumber >= base.currentItem;
        } else {
          follow = true;
        }

        if (follow && itemNumber < base.currentItem + base.options.items && $lazyImg.length) {
          base.lazyPreload($item, $lazyImg);
        }
      }
    },
    lazyPreload: function lazyPreload($item, $lazyImg) {
      var base = this,
          iterations = 0,
          isBackgroundImg;

      if ($lazyImg.prop("tagName") === "DIV") {
        $lazyImg.css("background-image", "url(" + $lazyImg.data("src") + ")");
        isBackgroundImg = true;
      } else {
        $lazyImg[0].src = $lazyImg.data("src");
      }

      function showImage() {
        $item.data("owl-loaded", "loaded").removeClass("loading");
        $lazyImg.removeAttr("data-src");

        if (base.options.lazyEffect === "fade") {
          $lazyImg.fadeIn(400);
        } else {
          $lazyImg.show();
        }

        if (typeof base.options.afterLazyLoad === "function") {
          base.options.afterLazyLoad.apply(this, [base.$elem]);
        }
      }

      function checkLazyImage() {
        iterations += 1;

        if (base.completeImg($lazyImg.get(0)) || isBackgroundImg === true) {
          showImage();
        } else if (iterations <= 100) {
          //if image loads in less than 10 seconds 
          window.setTimeout(checkLazyImage, 100);
        } else {
          showImage();
        }
      }

      checkLazyImage();
    },
    autoHeight: function autoHeight() {
      var base = this,
          $currentimg = $(base.$owlItems[base.currentItem]).find("img"),
          iterations;

      function addHeight() {
        var $currentItem = $(base.$owlItems[base.currentItem]).height();
        base.wrapperOuter.css("height", $currentItem + "px");

        if (!base.wrapperOuter.hasClass("autoHeight")) {
          window.setTimeout(function () {
            base.wrapperOuter.addClass("autoHeight");
          }, 0);
        }
      }

      function checkImage() {
        iterations += 1;

        if (base.completeImg($currentimg.get(0))) {
          addHeight();
        } else if (iterations <= 100) {
          //if image loads in less than 10 seconds 
          window.setTimeout(checkImage, 100);
        } else {
          base.wrapperOuter.css("height", ""); //Else remove height attribute
        }
      }

      if ($currentimg.get(0) !== undefined) {
        iterations = 0;
        checkImage();
      } else {
        addHeight();
      }
    },
    completeImg: function completeImg(img) {
      var naturalWidthType;

      if (!img.complete) {
        return false;
      }

      naturalWidthType = _typeof(img.naturalWidth);

      if (naturalWidthType !== "undefined" && img.naturalWidth === 0) {
        return false;
      }

      return true;
    },
    onVisibleItems: function onVisibleItems() {
      var base = this,
          i;

      if (base.options.addClassActive === true) {
        base.$owlItems.removeClass("active");
      }

      base.visibleItems = [];

      for (i = base.currentItem; i < base.currentItem + base.options.items; i += 1) {
        base.visibleItems.push(i);

        if (base.options.addClassActive === true) {
          $(base.$owlItems[i]).addClass("active");
        }
      }

      base.owl.visibleItems = base.visibleItems;
    },
    transitionTypes: function transitionTypes(className) {
      var base = this; //Currently available: "fade", "backSlide", "goDown", "fadeUp"

      base.outClass = "owl-" + className + "-out";
      base.inClass = "owl-" + className + "-in";
    },
    singleItemTransition: function singleItemTransition() {
      var base = this,
          outClass = base.outClass,
          inClass = base.inClass,
          $currentItem = base.$owlItems.eq(base.currentItem),
          $prevItem = base.$owlItems.eq(base.prevItem),
          prevPos = Math.abs(base.positionsInArray[base.currentItem]) + base.positionsInArray[base.prevItem],
          origin = Math.abs(base.positionsInArray[base.currentItem]) + base.itemWidth / 2,
          animEnd = 'webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend';
      base.isTransition = true;
      base.$owlWrapper.addClass('owl-origin').css({
        "-webkit-transform-origin": origin + "px",
        "-moz-perspective-origin": origin + "px",
        "perspective-origin": origin + "px"
      });

      function transStyles(prevPos) {
        return {
          "position": "relative",
          "left": prevPos + "px"
        };
      }

      $prevItem.css(transStyles(prevPos, 10)).addClass(outClass).on(animEnd, function () {
        base.endPrev = true;
        $prevItem.off(animEnd);
        base.clearTransStyle($prevItem, outClass);
      });
      $currentItem.addClass(inClass).on(animEnd, function () {
        base.endCurrent = true;
        $currentItem.off(animEnd);
        base.clearTransStyle($currentItem, inClass);
      });
    },
    clearTransStyle: function clearTransStyle(item, classToRemove) {
      var base = this;
      item.css({
        "position": "",
        "left": ""
      }).removeClass(classToRemove);

      if (base.endPrev && base.endCurrent) {
        base.$owlWrapper.removeClass('owl-origin');
        base.endPrev = false;
        base.endCurrent = false;
        base.isTransition = false;
      }
    },
    owlStatus: function owlStatus() {
      var base = this;
      base.owl = {
        "userOptions": base.userOptions,
        "baseElement": base.$elem,
        "userItems": base.$userItems,
        "owlItems": base.$owlItems,
        "currentItem": base.currentItem,
        "prevItem": base.prevItem,
        "visibleItems": base.visibleItems,
        "isTouch": base.browser.isTouch,
        "browser": base.browser,
        "dragDirection": base.dragDirection
      };
    },
    clearEvents: function clearEvents() {
      var base = this;
      base.$elem.off(".owl owl mousedown.disableTextSelect");
      $(document).off(".owl owl");
      $(window).off("resize", base.resizer);
    },
    unWrap: function unWrap() {
      var base = this;

      if (base.$elem.children().length !== 0) {
        base.$owlWrapper.unwrap();
        base.$userItems.unwrap().unwrap();

        if (base.owlControls) {
          base.owlControls.remove();
        }
      }

      base.clearEvents();
      base.$elem.attr("style", base.$elem.data("owl-originalStyles") || "").attr("class", base.$elem.data("owl-originalClasses"));
    },
    destroy: function destroy() {
      var base = this;
      base.stop();
      window.clearInterval(base.checkVisible);
      base.unWrap();
      base.$elem.removeData();
    },
    reinit: function reinit(newOptions) {
      var base = this,
          options = $.extend({}, base.userOptions, newOptions);
      base.unWrap();
      base.init(options, base.$elem);
    },
    addItem: function addItem(htmlString, targetPosition) {
      var base = this,
          position;

      if (!htmlString) {
        return false;
      }

      if (base.$elem.children().length === 0) {
        base.$elem.append(htmlString);
        base.setVars();
        return false;
      }

      base.unWrap();

      if (targetPosition === undefined || targetPosition === -1) {
        position = -1;
      } else {
        position = targetPosition;
      }

      if (position >= base.$userItems.length || position === -1) {
        base.$userItems.eq(-1).after(htmlString);
      } else {
        base.$userItems.eq(position).before(htmlString);
      }

      base.setVars();
    },
    removeItem: function removeItem(targetPosition) {
      var base = this,
          position;

      if (base.$elem.children().length === 0) {
        return false;
      }

      if (targetPosition === undefined || targetPosition === -1) {
        position = -1;
      } else {
        position = targetPosition;
      }

      base.unWrap();
      base.$userItems.eq(position).remove();
      base.setVars();
    }
  };

  $.fn.owlCarousel = function (options) {
    return this.each(function () {
      if ($(this).data("owl-init") === true) {
        return false;
      }

      $(this).data("owl-init", true);
      var carousel = Object.create(Carousel);
      carousel.init(options, this);
      $.data(this, "owlCarousel", carousel);
    });
  };

  $.fn.owlCarousel.options = {
    items: 5,
    itemsCustom: false,
    itemsDesktop: [1199, 4],
    itemsDesktopSmall: [979, 3],
    itemsTablet: [768, 2],
    itemsTabletSmall: false,
    itemsMobile: [479, 1],
    singleItem: false,
    itemsScaleUp: false,
    slideSpeed: 200,
    paginationSpeed: 800,
    rewindSpeed: 1000,
    autoPlay: false,
    stopOnHover: false,
    navigation: false,
    navigationText: ["prev", "next"],
    rewindNav: true,
    scrollPerPage: false,
    pagination: true,
    paginationNumbers: false,
    responsive: true,
    responsiveRefreshRate: 200,
    responsiveBaseWidth: window,
    baseClass: "owl-carousel",
    theme: "owl-theme",
    lazyLoad: false,
    lazyFollow: true,
    lazyEffect: "fade",
    autoHeight: false,
    jsonPath: false,
    jsonSuccess: false,
    dragBeforeAnimFinish: true,
    mouseDrag: true,
    touchDrag: true,
    addClassActive: false,
    transitionStyle: false,
    beforeUpdate: false,
    afterUpdate: false,
    beforeInit: false,
    afterInit: false,
    beforeMove: false,
    afterMove: false,
    afterAction: false,
    startDragging: false,
    afterLazyLoad: false
  };
})(jQuery, window, document);

},{}]},{},[1]);
